//@ts-nocheck
import React, { useEffect, useState } from 'react';
import * as d3 from 'd3';
import d3tip from 'd3-tip'
import { schemeCategory10  } from 'd3-scale-chromatic';
import * as Helpers from '../../Common/Helpers';
import { Heading3 } from '../../Common/SharedStyledComponents';
import { TitleDiv } from './Earnings';

const EmployeeCounts = ({ EmployeeBarPlot, statecode, employeeTypes, industries, title, parentWidth, state, props }) => {

    useEffect(() => {
        const industryGroups = industries.filter(i => i.selected).map(i => i.type);
        const employeeTypeGroups = employeeTypes.filter(e => e.selected).map(e => e.type);
        const filteredData = EmployeeBarPlot.filter(x => +x.statecode == statecode
            && employeeTypeGroups.includes(x.employee)
            && industryGroups.includes(x.industry));

        const maxCount = Math.max(...filteredData.map(d => d.count));

        var margin = { top: 25, right: 140, bottom: 60, left: 100 },
            //width = (parentWidth+50 || 890) - margin.left - margin.right,
            width = (900) - margin.left - margin.right,
            height = 350 - margin.top - margin.bottom;

        d3.select("#EmployeeChart svg").remove();

        if (filteredData.length > 0) {
            // append the svg object to the body of the page
            var svg = d3.select("#EmployeeChart")
                .append("svg")
                .attr("width", width + margin.left + margin.right)
                .attr("height", height + margin.top + margin.bottom)
                .append("g")
                .attr("transform",
                    "translate(105," + margin.top + ")");

            // Add X axis
            var x = d3.scaleBand()
                .domain(industryGroups)
                .range([0, width])
                .padding([0.2])

            var xAxis = svg.append("g")
                .attr("transform", "translate(0," + height + ")")
                .call(d3.axisBottom(x).tickSize(0).tickPadding(10))

            xAxis.attr("class", "tick_style");

            // Add Y axis
            var y = d3.scaleLinear()
                .domain([0, maxCount])
                .range([height, 0]);
            svg.append("g")
                .classed('tick_style', true)
                .call(d3.axisLeft(y).tickSizeOuter(0));

            // Another scale for subgroup position?
            var xSubgroup = d3.scaleBand()
                .domain(employeeTypeGroups)
                .range([0, x.bandwidth()])
                .padding([0.05])

            // color palette = one color per subgroup
            var color = d3.scaleOrdinal()
                .domain(["Undergraduate","Graduate Student", "Postdoc", "Staff", "Faculty", "Other Student"])
                .range(schemeCategory10)

            // Define the div for the tooltip
            var tooltip = d3.select("#EmployeeChart").append("div")
                .attr("class", "er_tooltip")
                .style("opacity", 0);

            // Show the bars
            svg.append("g")
                .selectAll("g")
                // Enter in data = loop group per group
                .data(industryGroups)
                .enter()
                .append("g")
                .attr("transform", d => "translate(" + x(d) + ",0)")
                .selectAll("rect")
                .data(function (d) {
                    return employeeTypeGroups.map(function (key) {
                        return { key: key, value: filteredData.find(i => i.industry == d && i.employee == key) };
                    });
                })
                .enter().append("rect")
                .attr("x", d => xSubgroup(d.key))
                .attr("y", d => (d.value != undefined) ? y(d.value.count) : y(0))
                .attr("width", xSubgroup.bandwidth())
                .attr("height", d => (d.value != undefined) ? height - y(d.value.count) : height - y(0))
                .attr("fill", d => color(d.key))
                .on('mouseover', d => {
                    const dataValue = d.target.__data__;

                    const tooltipHtml = `<b>Employee Count:</b><br/>${dataValue.value.count}`
                    
                    tooltip.style("opacity", .9);
                    tooltip.html(tooltipHtml)
                    .style("left", (d.layerX) + "px")
                    .style("top", (d.layerY) + "px");
                })
                .on("mouseout", function (d) {
                    tooltip.transition()
                        //.duration(500)
                        .style("opacity", 0);
                })
		
            const laptopScreenSize = 1060;
            svg.append("g")
                .selectAll("g")
                // Enter in data = loop group per group
                .data(industryGroups)
                .enter()
                .append("g")
                .attr("transform", d => "translate(" + x(d) + ",0)")
                .selectAll("text")
                .data(function (d) {
                    return employeeTypeGroups.map(function (key) {
                        return { key: key, value: filteredData.find(i => i.industry == d && i.employee == key) };
                    });
                })
                .enter()
                .append("text")
                //.classed('bar-title', true)
                .attr('text-anchor', 'middle')
                .attr("x", d => xSubgroup(d.key) +
                    (
                    employeeTypeGroups.length == 2 ? (parentWidth > laptopScreenSize ? 40 : 25) :
                    employeeTypeGroups.length == 3 ? (parentWidth > laptopScreenSize ? 25 : 18) :
                            employeeTypeGroups.length == 4 ? (parentWidth > laptopScreenSize ? 18 : 15)  :
                                employeeTypeGroups.length == 5 ? (parentWidth > laptopScreenSize ? 15 : 12)  :
                                    employeeTypeGroups.length == 6 ? (parentWidth > laptopScreenSize ? 12 : 10)  :
                                        (parentWidth > laptopScreenSize ? 80 : 60) )
                )
                .attr("y", d => (d.value != undefined) ? y(d.value.count) - 5 : y(0))
                .text(d => (d.value !== undefined) ? Helpers.numberWithCommas(d.value.count) : '');

            //Add Axis Labels
            svg.append("text")
                .attr("text-anchor", "end")
                .attr("x", width/2)
                .attr("y", height + margin.top + 30)
                .attr("stroke", "#1d2951")
                .attr("stroke-width", "0.1")
                .classed('axis_style', true)
                .text("Industry Name");

            svg.append("text")
                .attr("text-anchor", "end")
                .attr("transform", "rotate(-90)")
                .attr("y", -margin.left + 25)
                .attr("x", -margin.top - 40)
                .attr("stroke", "#1d2951")
                .attr("stroke-width", "0.1")
                .classed('axis_style', true)
                .text("Employee Count")

            //Add Legend
            // Add one dot in the legend for each name.
            var size = 20
            svg.selectAll("mydots")
                .data(employeeTypeGroups)
                .enter()
                .append("rect")
                .attr("x", width - 10)
                .attr("y", function (d, i) { return (-10) + i * (size + 5) }) // 100 is where the first dot appears. 25 is the distance between dots
                .attr("width", size)
                .attr("height", size)
                .style("fill", function (d) { return color(d) })

            // Add one dot in the legend for each name.
            svg.selectAll("mylabels")
                .data(employeeTypeGroups)
                .enter()
                .append("text")
                .attr("x", (width - 10) + size * 1.2)
                .attr("y", function (d, i) { return (-10) + i * (size + 5) + (size / 2) }) // 100 is where the first dot appears. 25 is the distance between dots
                .style("fill", function (d) { return color(d) })
                .text(function (d) { return d })
                .attr("text-anchor", "left")
                .style("alignment-baseline", "middle")
        }


    }, [statecode, employeeTypes, industries, parentWidth])

    return (
        <div id="chartEmployeeCounts" className="ChartComponent">
            <TitleDiv>
                <Heading3 bold center>{title}</Heading3>
            </TitleDiv>
            <div id="EmployeeChart"></div>
        </div>
    );
}

export default EmployeeCounts;